module.exports = __webpack_public_path__ + "img/icon-lotto-bill.3f1806a1.png";